import { Box, Flex, UserMenu, Text } from '@instamenu/ui-system-next';
import { themeVars } from '@instamenu/ui-vanilla-extract';
import { BackButton } from '../back-button/back-button';

export const OrderHeader = ({ onBack }: { onBack: () => void }) => (
  <Flex
    style={{
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: themeVars.pad[12],
      marginBottom: themeVars.pad[16],
    }}
  >
    <Box css={{ flex: '1 1 20%', display: 'flex', justifyContent: 'flex-start' }}>
      <BackButton onClick={onBack} />
    </Box>
    <Box css={{ textAlign: 'center' }}>
      <Text variant="h3">Your Order</Text>
    </Box>
    <Box css={{ flex: '1 1 20%', display: 'flex', justifyContent: 'flex-end' }}>
      <UserMenu />
    </Box>
  </Flex>
);
